import VueRouter, { RouteConfig } from "vue-router";

import Home from "../views/Home.vue";
import Language from "../components/Language.vue";
import Vue from "vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/:language",
    name: "language",
    component: Language,
    props: true,
    children: [
      {
        component: () =>
          import(
            /* webpackChunkName: "chronology" */ "../views/Chronology.vue"
          ),
        name: "chronology",
        path: "chronology",
        props: true
      },
      {
        component: () =>
          import(/* webpackChunkName: "citations" */ "../views/Citations.vue"),
        name: "citations",
        path: "citations/:manufactureId",
        props: true
      },
      {
        component: () =>
          import(
            /* webpackChunkName: "imageArchives" */ "../views/ImageArchives.vue"
          ),
        name: "imageArchives",
        path: "imageArchives/:manufactureId",
        props: true
      },
      {
        component: () =>
          import(/* webpackChunkName: "indiennes" */ "../views/Indiennes.vue"),
        name: "indiennes",
        path: "indiennes/:manufactureId",
        props: true
      },
      {
        component: () =>
          import(/* webpackChunkName: "main" */ "../views/Main.vue"),
        name: "main",
        path: "main",
        props: true
      },
      {
        component: () =>
          import(
            /* webpackChunkName: "manufacture" */ "../views/Manufacture.vue"
          ),
        name: "manufacture",
        path: "manufacture/:id",
        props: true
      },
      {
        component: () =>
          import(/* webpackChunkName: "map" */ "../views/Map.vue"),
        name: "map",
        path: "map",
        props: true
      },
      {
        component: () =>
          import(/* webpackChunkName: "places" */ "../views/Places.vue"),
        name: "places",
        path: "places",
        props: true
      },
      {
        component: () =>
          import(/* webpackChunkName: "place" */ "../views/Place.vue"),
        name: "place",
        path: "place/:id",
        props: true
      }
    ]
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});

export default router;
